import React, { useState, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import DocumentTitle from 'react-document-title'
import Countdown from 'react-countdown'
import _ from 'lodash'

import { Grid, withStyles } from '@material-ui/core'
import { Box, Typography } from '@mui/material'

import Section from 'components/Section/Section'
import { Controller, useForm } from 'react-hook-form'

import Button from 'components/CustomButtons/Button.jsx'
import registerStyle from 'assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx'
import compose from 'utils/compose'
import Header from '../../../../CreateUser/components/Header'
import Footer from '../../../../CreateUser/components/Footer'
import * as Style from './styles'
import RegisterIndicationInput from 'components/RegisterIndicationInput'

import {
	GetThemeFromAPILogin,
	SetThemeIntoStorage,
} from 'redux/api/themeColor'
import { GetGeneralRulesData } from 'redux/api/generalRules'
import { GetContact } from 'redux/api/footer'
import { handleAuthLogout } from 'utils'
import { getProgramTitle } from 'utils/utils'

// MOMENT JS
import * as moment from 'moment'


const langg = localStorage.getItem('i18nextLng')
moment.globalLocale = langg !== null ? langg.toLowerCase() : 'pt-BR'

const renderer = ({
	minutes,
	seconds,
	completed,
	isCompleted,
	setIsCompleted,
}) => {
	if (completed) {
		setIsCompleted(true)
		return null
	} else {
		return (
			!isCompleted && (
				<span>
					{minutes < 10 ? `0${minutes}` : minutes}:
					{seconds < 10 ? `0${seconds}` : seconds}
				</span>
			)
		)
	}
}

const AuthCodeVerification = ({
	onSubmit,
	requestSmsCode,
	props,
	isLoading,
	handleSent,
	consumer,
	hideOnEcommerce,
	isEcommerce,
	themeColor,
	emailToken,
}) => {
	let [date, setDate] = useState()
	const errorsToken = props?.emailToken?.errors
	const userData = props?.emailToken?.data
	const [hideCounter, setHideCounter] = useState(false)
	const [isCompleted, setIsCompleted] = useState(false)
	const [programName, setProgramName] = useState('')

	const [contact, setContat] = useState()
	const [loading, setLoading] = useState(true)

	const [timer, setTimer] = useState({
		time: 1000 * 120,
		isActive: false,
	})

	const { t } = useTranslation()

	const {
		handleSubmit,
		control,
		watch,
		errors,
		setValue,
		formState: { isSubmitting },
	} = useForm({
		defaultValues: {
			numberToken: '',
		},
	})

	const value = watch('numberToken')

	const GetContactInfo = async () => {
		const res = await GetContact()
		res && setContat(res)
	}

	const handleTimer = async () => {
		setLoading(true)
		try {
			handleSent()
			await requestSmsCode()

			setIsCompleted(false)
			setDate(Date.now() + timer.time)
			setTimer((prev) => ({
				...prev,
				isActive: true,
			}))
		} catch (error) {
			console.log(error)
		} finally {
			setLoading(false)
		}
	}

	const GetGeneralRulesBasic = () => {
		GetGeneralRulesData()
			.then((res) => {
				if (!_.isEmpty(res)) {
					setProgramName(res?.name)
					localStorage.setItem(
						'GeneralRulesBasic',
						JSON.stringify(res),
					)
				}
			})
			.catch((err) => console.log(err))
	}

	const getTheme = async () => {
		setLoading(true)
		try {
			const theme = await GetThemeFromAPILogin()

			SetThemeIntoStorage(theme)
		} catch (error) {
			console.log(error)
			handleAuthLogout()
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		setDate(Date.now() + timer.time)
	}, [])

	useEffect(() => {
		if (
			errorsToken?.length > 1 &&
			errorsToken[0]?.message !== 'consumer - EMAIL_ALREADY_VALIDATED'
		) {
			setHideCounter(true)
		}
		GetGeneralRulesBasic()
		GetContactInfo()
		getTheme()
	}, [])

	useMemo(() => {
		if (isCompleted) setValue('numberToken', '')
	}, [isCompleted])

	useMemo(() => {
		if (props?.putSms?.errors?.length > 0) setValue('numberToken', '')
	}, [props.putSms])

	const getPhoneNumber = (user = {}) => {
		const cpf = userData?.cpf ?? emailToken?.cpf;
		if (!cpf) return '';

		const isCpf = cpf.length === 11;

		if (isCpf) {
			return userData?.phoneNumber2 || emailToken?.phoneNumber2 || consumer?.phoneNumber2 || '';
		}

		return user.representative?.phoneNumber || consumer?.representative?.phoneNumber || emailToken?.representative?.phoneNumber || '';
	};


	const disableButton = (value?.length ?? 0) < 4 || isSubmitting;

	return loading ? (
		<div>...</div>
	) : (
		<form
			style={{
				width: '100%',
				height: '100%',
				display: isLoading ? 'none' : 'block',
				minHeight: '100vh'
			}}
			onSubmit={handleSubmit(onSubmit)}
		>

			<DocumentTitle
				title={getProgramTitle(t('TITLE_REGISTER_CONFIRMATION'))}
			/>

			<Style.Container container style={{ flexGrow: 1, flex: 1 }}>

				<Grid
					item
					md={isEcommerce ? 12 : 8}
					xs={12}
					sm={12}
					container
					alignItems="center"
					justifyContent="center"
				>
					{hideOnEcommerce(<Header isOptions={false} />)}


					{/* #1 DADOS PESSOAIS */}
					<Box
						width="100%"
						maxWidth="590px"
						display="flex"
						flexDirection="column"
						gap="10px"
						p={{
							xs: '10px',
							sm: '20px',
							md: '0px',
						}}
					>
						<Section title={t('TITLE_ACCESS_AUTHENTICATION')} divider={false} />
						<Style.SectionInfo>
							<p>
								Para ter acesso ao portal do <b>{programName}</b> {' '}
								informe o código enviado para
							</p>
							<p> o celular
								cadastrado,{' '}
								<Style.CellHidden themeColor={themeColor}>
									{getPhoneNumber()}
								</Style.CellHidden>{' '}
							</p>
							<p>
								Caso não tenha recebido, aguarde o tempo
								informado e solicite um novo.
							</p>
							<Box p="10px 14px" borderRadius="9px" bgcolor="#F0F0F0" mt={1}>
								<p>
									É importante que seu número de telefone esteja correto, pois receberá um sms com o código de ativação,
									caso esteja errado entrar em contato com o gestor.
								</p>
							</Box>

						</Style.SectionInfo>
						<Box
							item
							xs={12}
							md={12}
							className="numberTokenClass"
							sx={{
								textAlign: 'center',
								"& .title_kVVVRq": {
									mb: "30px",
								}
							}}
						>
							<Controller
								as={
									<RegisterIndicationInput
										title={
											'Utilize o código enviado para autenticação:'
										}
										hasBackground={false}
										validChars="0-9"
										amount={4}
										disabled={isCompleted}
										error={errors?.numberToken?.message}
										defaultTheme={themeColor}
									/>
								}
								name="numberToken"
								control={control}
							/>
						</Box>
						<Box
							display="flex"
							justifyContent="center"
							alignItems="center"
							flexDirection="column"
							p="20px 0px"
						>
							{!isCompleted && <p>Nova validação</p>}
							<div
								style={{
									fontWeight: 800,
									fontSize: '20px',
									color:
										themeColor?.navigation?.buttons
											?.backgroundColor || '',
								}}
							>
								{!hideCounter ? (
									<Countdown
										key={date}
										date={date}
										renderer={(props) =>
											renderer({
												...props,
												isCompleted,
												setIsCompleted,
											})
										}
									/>
								) : (
									''
								)}
							</div>
						</Box>
						<Box
							display="flex"
							flexDirection={{
								xs: 'column',
								md: 'row',

							}}
							justifyContent="center"
							alignItems="center"
							gap={1}
						>

							<Box
								sx={{
									width: '100%',
									maxWidth: '200px',
									'.MuiButtonBase-root': {
										backgroundColor: disableButton && '#B4B4B4 !important'
									},
								}}
							>
								<Button
									size="sm"
									fullWidth
									color="greenButtonColor"
									defaultTheme={themeColor}
									disabled={disableButton}
									type="submit"
								>
									{t('BUTTON_CONFIRM')}
								</Button>
							</Box>



							<Box
								sx={{
									width: '100%',
									maxWidth: '200px',
									'.MuiButton-root': {
										border:
											`1px solid ${isCompleted
												? themeColor
													?.navigation
													?.buttons
													?.backgroundColor
												: '#B4B4B4'
											}` + ' !important',
									},
								}}
							>
								<Button
									onClick={handleTimer}
									size="sm"
									fullWidth
									defaultTheme={themeColor}
									variant="contained"
									disabled={!isCompleted}
									color="greenBorderButtonColor"
									style={{
										textAlign: 'center',
										cursor: 'pointer',
										backgroundColor: '#fff',

										borderRadius: '5px',
										padding: '5px',
										color: isCompleted
											? themeColor?.navigation
												?.buttons
												?.backgroundColor
											: '#B4B4B4',
									}}
								>
									{t('BUTTON_REQUEST_NEW_TOKEN_CODE')}
								</Button>

							</Box>
						</Box>
						<Box width="100%" height="1px" bgcolor="#C4C4C4" maxWidth="800px" m="50px 0px" />
						<Box display="flex" flexDirection="column" alignItems="center" mb="20px">
							<Typography variant='body1' color="#333333" fontSize={"15px"}>
								Se tiver problemas com o código entre em contato
								com:
							</Typography>
							<Typography
								component='a'
								variant='body1'
								color="#333333"
								fontWeight={700}
								fontSize={"15px"}
								target="_blank"
								href={`mailto:${contact?.contactEmail}`}
							>
								{contact?.contactEmail || ''}
							</Typography>
						</Box>
					</Box>
				</Grid>
				{hideOnEcommerce(
					<Grid
						item
						xs={12}
						sm={12}
						md={4}
					>
						<Footer contact={contact} t={t} />
					</Grid>
				)}

			</Style.Container>
		</form >
	)
}

export default compose(withStyles(registerStyle))(AuthCodeVerification)
